import * as v from "valibot";

export const toMainPayloadSchema = v.variant("type", [
  v.object({ type: v.literal("frame:ready") }),
  v.object({
    type: v.literal("extension:ready"),
    name: v.string(),
  }),
  v.object({
    type: v.literal("extension:message"),
    name: v.string(),
    payload: v.unknown(),
  }),
]);

export type ToMainPayload = v.InferOutput<typeof toMainPayloadSchema>;

export const toMainMessageSchema = v.object({
  frameId: v.string(),
  payload: toMainPayloadSchema,
});

export const toFrameMessageSchema = v.variant("type", [
  v.object({
    type: v.literal("extension:message"),
    name: v.string(),
    payload: v.unknown(),
  }),
  v.object({
    type: v.literal("frame:morphed"),
  }),
]);

export type ToFrameMessage = v.InferOutput<typeof toFrameMessageSchema>;
